import React from 'react';
import StudentQuestionList from './views/Questions/StudentQuestionList';

const Dashboard = React.lazy(() => import('./views/Dashboard'));
const StudentDashboard = React.lazy(() => import('./views/StudentDashboard/StudentDashboard'));
const Reports = React.lazy(() => import('./views/Reports/Reports'));
const Notifications = React.lazy(() => import('./views/Notifications/Notifications'));
const StudentFeedback = React.lazy(() => import('./views/StudentFeedback/StudentFeedback'));
const DataPools = React.lazy(() => import('./views/DataPool/DataPools'));
const Settings = React.lazy(() => import('./views/Settings/Settings'));

//Information
const AddInformation = React.lazy(() => import('./views/Information/AddInformation'));
const InformationList = React.lazy(() => import('./views/Information/InformationList'));
const InformationViewEdit = React.lazy(() => import('./views/Information/InformationViewEdit'));
const AddbackgroundImage = React.lazy(() => import('./views/Information/AddbackgroundImage'));
const BackgroundImageList = React.lazy(() => import('./views/Information/BackgroundImageList'));
const BackgroundImageViewEdit = React.lazy(() => import('./views/Information/BackgroundImageViewEdit'));
const AddCourseMapElementImages = React.lazy(() => import('./views/Information/AddCourseMapElementImages'));
const CourseMapElementImagesList = React.lazy(() => import('./views/Information/CourseMapElementImagesList'));
const CourseMapElementImagesViewEdit = React.lazy(() => import('./views/Information/CourseMapElementImagesViewEdit'));
const AddSeriesIcons = React.lazy(() => import('./views/Information/AddSeriesIcons'));

//Users
const Users = React.lazy(() => import('./views/Users/Users'));
const UserProfile = React.lazy(() => import('./views/Users/UserProfile'));
const Colleagues = React.lazy(() => import('./views/Colleagues/Colleagues'));

//LODs
const LevelsOfDifficulty = React.lazy(() => import('./views/LevelsOfDifficulty/LevelsOfDifficulty'));

//Click Image Tree
const ClickImageAnswers = React.lazy(() => import('./views/ClickImageAnswers/ClickImageAnswers'));

//Click Interpreted Image Tree
const ClickInterpretedImageAnswers = React.lazy(() => import('./views/ClickInterpretedImageAnswers/ClickInterpretedImageAnswers'));

//Courses
const AddCourse = React.lazy(() => import('./views/Courses/AddCourse'));
const AddCourseMap = React.lazy(() => import('./views/Courses/AddCourseMap'));
const CourseMapPlayView = React.lazy(() => import('./views/Courses/CourseMapPlayView'));
const CourseMapTestView = React.lazy(() => import('./views/Courses/CourseMapTestView'));
const CourseMapPlayWithKeyView = React.lazy(() => import('./views/Courses/CourseMapPlayWithKeyView'));

const CourseMapEditView = React.lazy(() => import('./views/Courses/CourseMapEditView'));

const CoursesList = React.lazy(() => import('./views/Courses/CoursesList'));
const CourseView = React.lazy(() => import('./views/Courses/CourseView'));
const StudentCourseView = React.lazy(() => import('./views/Courses/StudentCourseView'));

//Keyboard
const AddKey = React.lazy(() => import('./views/Keyboard/AddKey'));
const AddKeyboard = React.lazy(() => import('./views/Keyboard/AddKeyboard'));
const AddKeyList = React.lazy(() => import('./views/Keyboard/AddKeyList'));
const KeysList = React.lazy(() => import('./views/Keyboard/KeysList'));
const KeysListList = React.lazy(() => import('./views/Keyboard/KeysListList'));
const KeyListViewEdit = React.lazy(() => import('./views/Keyboard/KeyListViewEdit'));
const KeyboardsList = React.lazy(() => import('./views/Keyboard/KeyboardList'));

//Questions
const AddQuestion = React.lazy(() => import('./views/Questions/AddQuestionUpdated'));
const QuestionsList = React.lazy(() => import('./views/Questions/QuestionsList'));
const ClickableQuestionViewEdit = React.lazy(() => import('./views/Questions/ClickableQuestionViewEdit'));
const KeyboardQuestionViewEdit = React.lazy(() => import('./views/Questions/KeyboardQuestionViewEdit'));
const QuestionViewEdit = React.lazy(() => import('./views/Questions/QuestionViewEdit'));

const StudentQuestionsList = React.lazy(() => import('./views/Questions/StudentQuestionList'));
const AddKeyboardQuestion = React.lazy(() => import('./views/Questions/AddKeyboardQuestion'));
const AddMultipleChoiceQuestion = React.lazy(() => import('./views/Questions/AddMultipleChoiceQuestion'));
const AddDiagramsQuestion = React.lazy(() => import('./views/Questions/AddDiagramsQuestion'));
const AddDynamicsQuestion = React.lazy(() => import('./views/Questions/AddDynamicsQuestion'));
const AddEnergyBalanceQuestion = React.lazy(() => import('./views/Questions/AddEnergyBalanceQuestionUpdated'));

const CreateQuestionSeries = React.lazy(() => import('./views/Questions/CreateQuestionSeries'));
const QuestionSeriesList = React.lazy(() => import('./views/Questions/QuestionSeriesList'));
const QuestionSeriesView = React.lazy(() => import('./views/Questions/QuestionSeriesView'));
const QuestionSeriesPlay = React.lazy(() => import('./views/Questions/QuestionSeriesPlay'));
const OnTheFlySeries = React.lazy(() => import('./views/Questions/OnTheFlySeries'));

const PlayQuestion = React.lazy(() => import('./views/Questions/PlayQuestion'));

//Topics
const Topics = React.lazy(() => import('./views/Topics/Topics'));

//Challenges
const Challenges = React.lazy(() => import('./views/Challenges/Challenges'));

//Admin
const AdminOwnership = React.lazy(() => import('./views/AdminOwnership/AdminOwnership'));

//Latex
const LatexForApp = React.lazy(() => import('./views/Questions/LatexForApp'));

//Default QuestionImage
const AddDefaultQuestionImage = React.lazy(() => import('./views/Questions/AddDefaultQuestionImage'));
const DefaultQuestionImagesList = React.lazy(() => import('./views/Questions/DefaultQuestionImagesList'));


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/reports', name: 'Reports', component: Reports },
  { path: '/Notifications', name: 'Notifications', component: Notifications },
  { path: '/StudentFeedback', name: 'Student feedback', component: StudentFeedback },
  { path: '/student_dashboard', name: 'Dashboard', component: StudentDashboard },
  { path: '/Settings', name: 'Datapools', component: Settings },

  //Information
  { path: '/Information/Add', name: 'Add Information', component: AddInformation },
  { path: '/Information/AddBI', name: 'Add Background Image', component: AddbackgroundImage },
  { path: '/Information/AddMEIL', name: 'Add Map Element Image List', component: AddCourseMapElementImages },
  { path: '/Information/AddSeriesIcons', name: 'Add Series Icons', component: AddSeriesIcons },
  { path: '/Information/ListMEIL', name: 'Map Element Image List', component: CourseMapElementImagesList },
  { path: '/Information/List', name: 'Information list', component: InformationList },
  { path: '/Information/ListBI', name: 'Background Images', component: BackgroundImageList },
  { path: '/Information/ViewEdit/:Id', name: 'Information', component: InformationViewEdit },
  { path: '/Information/ViewEditBI/:Id', name: 'Backround Image', component: BackgroundImageViewEdit },
  { path: '/Information/ViewEditMEI/:Id', name: 'Map Element Image List', component: CourseMapElementImagesViewEdit },

  //Users
  { path: '/Users', name: 'User', component: Users },
  { path: '/DataPools', name: 'Datapools', component: DataPools },
  { path: '/UserProfile', name: 'User Profile', component: UserProfile },
  { path: '/Colleagues', name: 'Colleagues', component: Colleagues },

  //LODs
  { path: '/LODs', name: 'Levels of Difficulty', component: LevelsOfDifficulty },

  //Click Image Answers
  { path: '/ClickImageAnswers', name: 'Click Image Trees', component: ClickImageAnswers },

  //Click Interpreted Image Tree
  { path: '/ClickInterpretedImageAnswers', name: 'Click Interpreted Image Trees', component: ClickInterpretedImageAnswers },

  //Courses
  { path: '/Courses/Add', name: 'Add Course', component: AddCourse },

  { path: '/Courses/AddCourseMap', name: 'Add Map Course', component: AddCourseMap },
  { path: '/Courses/PlayMap/:id', name: 'Play Map', component: CourseMapPlayView },
  { path: '/Courses/TestMap/:id', name: 'Play Map', component: CourseMapTestView },
  { path: '/Courses/PlayMapWithKey/:id', name: 'Play Map With Key', component: CourseMapPlayWithKeyView },

  { path: '/Courses/CourseMapEditView/:id', name: 'Course Map View Edit', component: CourseMapEditView },

  { path: '/Courses/List', name: 'Courses List', component: CoursesList },
  { path: '/Courses/CourseView/:id', name: 'CourseView', component: CourseView },
  { path: '/Courses/StudentCourseView/:id', name: 'CourseView', component: StudentCourseView },

  //Questions
  { path: '/Questions/AddC', name: 'Add Clickable Question', component: AddQuestion },
  { path: '/Questions/List', name: 'Questions List', component: QuestionsList },
  //{ path: '/Questions/StudentList', name: 'Questions List', component: StudentQuestionsList },
  { path: '/Questions/AddK', name: 'Add Keyboard Question', component: AddKeyboardQuestion },
  { path: '/Questions/AddMC', name: 'Add Multiple Choice Question', component: AddMultipleChoiceQuestion },
  { path: '/Questions/AddDQ', name: 'Add Diagrams Question', component: AddDiagramsQuestion },
  { path: '/Questions/AddFBDQ', name: 'Add Dynamics Question', component: AddDynamicsQuestion },
  { path: '/Questions/AddEBQ', name: 'Add Dynamics Question', component: AddEnergyBalanceQuestion },
  { path: '/Questions/AddDefaultImage', name: 'Add Default Question Image', component: AddDefaultQuestionImage },
  { path: '/Questions/DefaultQuestionImagesList', name: 'Default Question Images List', component: DefaultQuestionImagesList },

  { path: '/Questions/AddQuestionSeries', name: 'Add Question Series', component: CreateQuestionSeries },
  { path: '/Questions/QuestionSeriesList', name: 'Question Series List', component: QuestionSeriesList },
  { path: '/Questions/QuestionSeriesPlay/:Code', name: 'Question Series', component: QuestionSeriesPlay },
  { path: '/Questions/QuestionSeriesView/:Code', name: 'Question Series', component: QuestionSeriesView },
  { path: '/Questions/OnTheFlySeries/', name: 'On The Fly Question Series', component: OnTheFlySeries },


  { path: '/Questions/ClickableQuestionViewEdit/:id', name: 'Clickable Question', component: ClickableQuestionViewEdit },
  { path: '/Questions/QuestionViewEdit/:id/:type', name: 'Question View Edit', component: QuestionViewEdit },
  { path: '/Questions/KeyboardQuestionViewEdit/:id', name: 'Keyboard Question', component: KeyboardQuestionViewEdit },

  { path: '/Questions/PlayQuestion/:id/:type', name: 'Play Question', component: PlayQuestion },
  { path: '/Questions/LatexForApp/:Latex', name: 'Play Question', component: LatexForApp },

  //Keyboard
  { path: '/Keyboard/AddKey', name: 'Add Key', component: AddKey },
  { path: '/Keyboard/AddKeyboard', name: 'Add Keyboard', component: AddKeyboard },
  { path: '/Keyboard/AddKeyList', name: 'Add Key List', component: AddKeyList },
  { path: '/Keyboard/KeysList', name: 'Keys List', component: KeysList },
  { path: '/Keyboard/KeysListList', name: 'Keys List', component: KeysListList },
  { path: '/Keyboard/KeysListViewEdit/:Id', name: 'Keys List', component: KeyListViewEdit },
  { path: '/Keyboard/KeyboardsList', name: 'Keyboards List', component: KeyboardsList },

  //Topics
  { path: '/Topics', name: 'Topics', component: Topics },

  //Challenges
  { path: '/Challenges', name: 'Topics', component: Challenges },
  //Admin
  { path: '/Ownership', name: 'Ownership', component: AdminOwnership },

];

export default routes;
